import React, { useState, useEffect } from 'react';
import { GoogleMap, LoadScript, Circle } from '@react-google-maps/api';


const mapContainerStyle = { width: '100%', height: '400px',maxWidth:'400px' };
const options = {
    draggable: false,
    zoomControl: false, // disables zoom controls
    scrollwheel: false, // prevents zooming with the mouse scroll wheel
    disableDoubleClickZoom: true, // prevents zooming with double-click
    draggable: false, // prevents panning by dragging
    gestureHandling: 'none', // disables all map gestures
    streetViewControl: false,
    mapTypeControl: false,
    panControl: false,
    rotateControl: false,
    fullscreenControl: false
};

function MapAreaSelector_Michigan(props) {
    //,
    const [center, setCenter] = useState({ lat: 42.7335414, lng: -84.5555663 });
    const [circleCenter, setCircleCenter] = useState({ lat: props.lat == undefined ? 42.7335414 : props.lat, lng: props.lng == undefined ? -84.5555663 : props.lng });
    const [radius, setRadius] = useState(40000); // 200 miles in meters
    

    useEffect(() => {
       
    }, []);

    const handleDragEnd = (event) => {
      
    };

    const handleClick = (event) => {
        if(event) {
            setCircleCenter({
                lat: event.latLng.lat(),
                lng: event.latLng.lng()
            });
            if (props.onChange !== undefined) {
                props.onChange({
                    lat: event.latLng.lat(),
                    lng: event.latLng.lng()
                });
            }
        }
    }

    return (
       
            <GoogleMap
                mapContainerStyle={mapContainerStyle}
                center={center}
                zoom={6}
                options={options}
                onClick={handleClick }
            >
                <Circle
                    center={circleCenter}
                    radius={radius}
                    options={{
                        strokeColor: "#c02727",
                        fillColor: "#c02727",
                        draggable: true
                    }}
                    onDragEnd={handleDragEnd}
                />
            </GoogleMap>
      
    );
} export default React.memo(MapAreaSelector_Michigan)

